import React from 'react';
import Image from 'next/image';

import useMediaQuery from 'utils/useMediaQuery';
import { ReloanCalculator } from 'components/ReloanCalculator';

import styles from './ReloanHero.module.scss';

export const ReloanHero: React.FC = () => {
  const [isMobile, setIsMobile] = React.useState(Boolean);
  const max768px = useMediaQuery('(max-width: 768px)');

  React.useEffect(() => {
    setIsMobile(max768px);
  }, [max768px]);

  const mobileSrc = '/assets/images/reloan-hero-mobile-3-min.jpg';
  const desktopSrc = '/assets/images/reloan-hero-desktop-3-min.jpg';
  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <Image
          layout="fill"
          objectFit="cover"
          src={isMobile ? mobileSrc : desktopSrc}
          alt="Två personer sitter avslappnat på taket av en bil och njuter av utsikten"
          quality={isMobile ? 100 : 100}
        />
        <div className={styles.texts}>
          <h1>
            Flytta ditt billån och <span>sänk din månadskostnad</span>
          </h1>
          <p>
            Var först ut när Blipp lanserar Re:loan!
            <br />
            En helt ny tjänst där du kan flytta ditt billån, spara pengar och få bättre villkor.
          </p>
          <ul>
            <li>Lägre månadskostnad och bättre villkor</li>
            <li>Gäller både billån med säkerhet och privatlån</li>
            <li>Möjlighet att lägga om försäkringen till 20% rabatt</li>
          </ul>
        </div>
        <div className={`${styles.texts} ${styles.calculatorWrapper}`}>
          <ReloanCalculator />
        </div>
      </div>
    </div>
  );
};
